import { render, staticRenderFns } from "./workHistory.vue?vue&type=template&id=bf6a991a&scoped=true&"
import script from "./workHistory.vue?vue&type=script&lang=js&"
export * from "./workHistory.vue?vue&type=script&lang=js&"
import style0 from "./workHistory.vue?vue&type=style&index=0&id=bf6a991a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf6a991a",
  null
  
)

export default component.exports